import { PROBLEM_BADGE_STYLE, PROBLEM_LABEL } from "@/lib/callProblem";
import { type CallProblem } from "@/lib/types";

export const ProblemBadge = ({ problem }: { problem: CallProblem }) => (
  <span
    className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs ${PROBLEM_BADGE_STYLE[problem.kind]}`}
  >
    {PROBLEM_LABEL[problem.kind]}
  </span>
);
